<template>
  <div class="home pr-3 pl-3">
    <p class="h2 text-center mt-sm-4 mt-md-5 mt-4">{{ $t('home_title') }}</p>
    <hr class="underline">
    <div class="introduction mt-md-5 mb-4 text-justify">
        <p class="intro">
            {{ $t('home_intro1') }}
            <br>
            <br>
            {{ $t('home_intro2') }}
        </p>
    </div>
    <div class="stories row">
        <div class="story b-right col-md-6 m-0">
            <div class="image col-12">
                <img src="@/assets/0.1.jpg" />
            </div>
            <div class="text col-12">
                {{ $t('home_story1') }}
            </div>
        </div>
        <hr class="divider d-md-none col-12" style="transform: rotate(179.9deg)">
        <div class="story b-left col-md-6 m-0">
            <div class="image col-12">
                <img src="@/assets/0.2.jpg" />
            </div>
            <div class="text col-12">
                {{ $t('home_story2') }}
            </div>
        </div>
        <hr class="divider col-12" style="transform: rotate(179.9deg)">
        <div class="story b-right col-md-6 m-0">
            <div class="image col-12">
                <img src="@/assets/0.3.jpg" />
            </div>
            <div class="text col-12">
                {{ $t('home_story3') }}
            </div>
        </div>
        <hr class="divider d-md-none col-12" style="transform: rotate(179.9deg)">
        <div class="story b-left col-md-6 m-0">
            <div class="image col-12">
                <img src="@/assets/0.4.jpg" />
            </div>
            <div class="text col-12">
                {{ $t('home_story4') }}
            </div>
        </div>
    </div>
    <p class="note">
        {{ $t('home_note1') }}
    </p>
    <router-link class="button-link" :to="'/'+$route.params.locale+'/comic/start'"><md-button class="button md-primary ml-auto mr-auto mt-4 mb-2 d-block">{{ $t('home_button') }}</md-button></router-link>
  </div>
</template>

<script>
import i18n from '@/plugins/i18n';

export default {
  name: 'home',
  data() {
    return {
      language: ''
    }
  },
  created() {
    switch (i18n.locale) {
        case 'es':
            this.language = 'es';
            break;
        case 'pt':
            this.language = 'pt-pt';
            break;
        case 'it':
            this.language = 'it';
            break;
        case 'cz':
            this.language = 'cs';
            break;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "node_modules/bootstrap/scss/functions";
@import "node_modules/bootstrap/scss/variables";
@import "node_modules/bootstrap/scss/mixins/_breakpoints";

.home {
    max-width: 1000px;
    margin: auto;
    p.h2 {
        text-transform: uppercase;
        font-family: 'Kalam', sans-serif;
    }
    .underline {
        margin: 0 auto;
        border-width: 2px;
        max-width: 400px;
        border-color: #e31b18;
        margin-bottom: 25px;
    }
    .introduction {
        .intro {
            font-size: 0.95rem;
            color: black;
        }
    }
    .stories {
        background-color: white;
        border: solid black;
        border-width: 3px 4px 3px 4px;
        border-radius:60% 1% 20% 1%/0.3% 20% 1% 20%;
        overflow: hidden;
        .story {
            padding-top: 20px;
            padding-bottom: 20px;
            // &.b-right {
            //     border-right: 1px solid black;
            // }
            // &.b-left {
            //     border-left: 1px solid black;
            // }
            .text {
                font-family: "Architects Daughter", "Comic Sans MS";
                font-size: 1.15rem;
                line-height: 1.6rem;
                letter-spacing: 0.01rem;
                margin-top: 10px;
                text-align: justify;
            }
            .image {
                margin: auto;
            }
        }
        .divider {
            margin: 0;
            border-top: solid black;
            border-width: 3px;
            border-radius:100% 20% 2% 2%;
            transform: rotate(0.1deg)
        }
        @include media-breakpoint-down(md) {
            margin-left: 15px;
            margin-right: 15px;
            .story {
                .text {
                    font-size: 1.1rem;
                    line-height: 1.5rem;
                    letter-spacing: 0.007rem;
                }
            }
        }
        @include media-breakpoint-down(sm) {
            margin-left: 30px;
            margin-right: 30px;
        }
        @include media-breakpoint-down(xs) {
            margin-left: 0px;
            margin-right: 0px;
        }
    }
    .note {
        font-size: 0.9rem;
        color: rgba(0,0,0,0.7);
        margin-top: 15px;
    }
    .button {
        min-width: 200px;
        height: 50px;
        font-size: 1.3rem;
    }
    @include media-breakpoint-down(md) {
        .underline {
            max-width: 250px;
        }
        .button {
            min-width: 170px;
            height: 45px;
            font-size: 1.2rem;
        }
    }
}

.button-link:hover {
    text-decoration: none;
}

</style>

